<template>
  <section class="section about-contact">
    <div class="content-wrapper">
      <div class="about-info">
        <h2 class="section-title text-left">关于工作室</h2>
        <p class="desc">
          我们是一支由资深开发者、设计师和产品经理组成的极客团队。致力于通过前沿技术与卓越的设计理念，帮助企业完成数字化转型。
        </p>
        <p class="desc">
          不妥协于平庸，我们坚信“代码即艺术”。无论是从 0 到 1 的初创项目，还是复杂庞大的企业级系统，我们都能为您提供坚实的技术支撑。
        </p>
        <div class="stats">
          <div class="stat-item">
            <span class="num">50+</span>
            <span class="label">交付项目</span>
          </div>
          <div class="stat-item">
            <span class="num">100%</span>
            <span class="label">好评率</span>
          </div>
          <div class="stat-item">
            <span class="num">5年</span>
            <span class="label">行业经验</span>
          </div>
        </div>
      </div>
      
      <div class="contact-card card glow-bg">
        <h3 class="contact-title">开启您的项目</h3>
        <p class="contact-subtitle">填写需求，我们将于 24 小时内与您联系</p>
        
        <form class="contact-form" @submit.prevent="submitForm">
          <div class="form-group">
            <input type="text" placeholder="您的称呼" required />
          </div>
          <div class="form-group">
            <input type="tel" placeholder="联系电话/微信" required />
          </div>
          <div class="form-group">
            <textarea placeholder="简单描述您的需求..." rows="4" required></textarea>
          </div>
          <button type="submit" class="btn btn-primary submit-btn">提交需求</button>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutContactSection',
  methods: {
    submitForm() {
      alert('需求提交成功！我们会尽快与您联系。');
    }
  }
}
</script>

<style lang="scss" scoped>
.about-contact {
  padding-top: 100px;
  padding-bottom: 100px;
}

.content-wrapper {
  display: flex;
  gap: 80px;
  align-items: center;
}

.about-info {
  flex: 1;
}

.text-left {
  text-align: left;
  margin-bottom: 30px;
}

.desc {
  font-size: 16px;
  line-height: 1.8;
  color: var(--text-secondary);
  margin-bottom: 20px;
}

.stats {
  display: flex;
  gap: 40px;
  margin-top: 40px;
}

.stat-item {
  display: flex;
  flex-direction: column;
}

.num {
  font-size: 32px;
  font-weight: 800;
  color: var(--primary-color);
  margin-bottom: 4px;
}

.label {
  font-size: 14px;
  color: var(--text-secondary);
}

.contact-card {
  flex: 1;
  max-width: 500px;
  padding: 40px;
}

.contact-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 10px;
  color: var(--text-primary);
}

.contact-subtitle {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 30px;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  input, textarea {
    width: 100%;
    padding: 14px 16px;
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: #fcfcfc;
    font-size: 15px;
    font-family: inherit;
    transition: all var(--transition-speed) ease;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: var(--primary-color);
      background: white;
      box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
    }
  }
  
  textarea {
    resize: vertical;
  }
}

.submit-btn {
  width: 100%;
  padding: 16px;
  font-size: 16px;
  margin-top: 10px;
}

@media (max-width: 992px) {
  .content-wrapper {
    flex-direction: column;
  }
  
  .contact-card {
    width: 100%;
    max-width: 100%;
  }
}
</style>
